import { render } from "./FieldList.vue?vue&type=template&id=120070e0&ts=true"
import script from "./FieldList.vue?vue&type=script&lang=ts"
export * from "./FieldList.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__